import React from "react";
import "./service.css";
import AOS from "aos";
import "aos/dist/aos.css";
class Service extends React.Component {
  componentDidMount() {
    AOS.init({
      duration: 400,
    });
  }
  render() {
    return (
      <div>
        <div className="service">
          <div className="service_cont">
            <h3>Pickup or delivery</h3>
            <img
              src="/delivery.png"
              width="85%"
              alt="pickup"
              data-aos="fade-in"
              data-aos-delay="20"
              data-aos-duration="1200"
            />
            <h2>Electronics & more</h2>
            <h4>select pickup address or home delivery</h4>
          </div>
          <div className="service_cont">
            <h3>Earn 5% cash back</h3>
            <img
              src="/stripe.svg"
              width="85%"
              alt="cash back"
              data-aos="fade-in"
              data-aos-delay="20"
              data-aos-duration="1200"
            />
            <h2>Earn 5% cash back</h2>
            <h4>Each time you use stripe at check out</h4>
          </div>
          <div className="service_cont">
            <h3>No order minimum shipping</h3>
            <img
              src="/success.svg"
              width="85%"
              alt="Minimum Order"
              data-aos="fade-in"
              data-aos-delay="20"
              data-aos-duration="1200"
            />
            <h2 className="service_h2">All members</h2>
            <h4>Register today. Restrictions apply.</h4>
          </div>
        </div>
      </div>
    );
  }
}

export default Service;
